module.exports = __webpack_public_path__ + "img/dh-default.2b7b7d57.jpg";